<div [ngClass]="getStyleClass()" (click)="onSelect($event)">
  <ion-checkbox *ngIf="!hideCheckBox" [checked]="checked" [indeterminate]="indeterminate" [disabled]="disabled" />
  <span>
    <ng-content></ng-content>
  </span>
</div>
